export const DEV = process.env.NODE_ENV !== "production";
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY!;
export const GRAPHQL_URL = false
  ? "http://localhost:4000/graphql"
  : "https://api.logisticavaquer.com/graphql";
